
import { defineComponent } from "vue";

export default defineComponent({
  name: "ToggleSwitch",

  data() {
    return {
      checkboxValue: this.checked,
    };
  },

  props: {
    setting: { type: String, required: true },
    checked: { type: Boolean, required: false }, // the inital checked value
  },

  methods: {
    onChange() {
      this.$emit('update:checked', this.checkboxValue);
    },
  }
});
